import { render, staticRenderFns } from "./Categories-Show.vue?vue&type=template&id=a2a5dbfe&scoped=true&"
import script from "./Categories-Show.vue?vue&type=script&lang=js&"
export * from "./Categories-Show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a5dbfe",
  null
  
)

export default component.exports